class MetaData {
	mimeType = '';
	guaranteeId = '';
	type = '';
	environment = '';
}
export class GuaranteeRequestAttachment {
	chronicleId: string | undefined;
	versionId?: string;
	creationDateTime?: string;
	name = '';
	type = '';
	size = 0;
	path = '';
	creationDate = '';
	creationBy = '';
	deleted?: true;
	metaData: MetaData = {
		mimeType: '',
		guaranteeId: '',
		type: '',
		environment: ''
	};

	localUrl?: string | undefined;
}
